import DOMPurify from 'dompurify';
import { format, parse } from 'date-fns'

export const normalizePath = path => {

	const pathStr = path.split( '/');

	// If the path ends with '/' get the second last item
	if ( path?.endsWith( `/` ) ) {

		const strIndex = pathStr.length ? ( pathStr.length - 2 ) : '';

		if ( strIndex ) {
			path = `/${ pathStr[ strIndex ] }/`
		}
	}

	// If the path ends with '/' get the second last item.
	if ( ! path?.endsWith( `/` ) ) {
		const strIndex = pathStr.length ? ( pathStr.length - 1 ) : '';

		if ( strIndex ) {
			path = `/${ pathStr[ strIndex ] }/`
		}
	}

	return path;

}
/**
 * Get date in format of m-d-y
 *
 * @param {string} dateString Date string, example 2020-05-03T04:41:12
 *
 * @return {string}
 */
export const getFormattedDate = ( dateString, dateFormat = "DD-MM-YYYY", options = null ) => {

	if ( ! dateString ) {
		return '';
	}

	const locale = process.env.GATSBY_SITE_LANG.replace('_','-')
	var date

	if (options === "raw") {
		date = new Date( dateString );
	} else {
		date = new Date( parse(dateString, 'dd/MM/yyyy', new Date()) );
	}

	if (dateFormat === "DD-MM-YYYY") {
		return `${date.toLocaleDateString(locale, { year: "numeric", month: "numeric", day: "numeric"})}`;
	}

	if (dateFormat === "D MMMM Y") {
		return `${date.toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric"})}`;
	}

	if (dateFormat === "YYYYMMDD") {
		return format(date, "yyyyMMdd")
	}

};

/**
 * Get formatted Language
 *
 * @param {string}
 *
 * @return {string}
 */
 export const getFormattedLanguage = (lang) => {

	 const formattedLang = lang.replace('_', '-');

   switch (formattedLang) {
		 case 'en-US':
       return 'en';
		 case 'it-IT':
			 return 'it';
     case 'fr-FR':
       return 'fr';
     case 'de-DE':
       return 'de';
     case 'es-ES':
       return 'es';
     case 'pt-PT':
       return 'pt';
     case 'zh-CN':
       return 'zh';
     default:
       return lang;
   }
 };

/**
 * Remove the trailing slash from a string.
 *
 * @param {String } targetString Target string.
 * @return {string} String with trailing slash removed.
 */
export const removeTrailingSlash = ( targetString ) => {
	if ( ! targetString ) {
		return '';
	}

	return targetString.replace(/\/$/, "")
}

/**
 * Sanitize markup or text when used inside dangerouslysetInnerHTML
 *
 * @param {string} content Plain or html string.
 *
 * @return {string} Sanitized string
 */
export const sanitize = (content) => {

	// return typeof window === 'undefined' ? DOMPurify.sanitize(content) : content

	return content;

}

/**
 * Strip HTML tags from a string.
 *
 * This function uses a regular expression to identify and remove HTML tags
 * from the input string, leaving plain text.
 *
 * @param {string} content The string to process, which may contain HTML tags.
 * @return {string} The string with HTML tags removed.
 */
export const removeTags = (str) => {
  if ((str === null) || (str === '')) return false;
  else str = str.toString();

  // Use a regular expression to remove HTML tags from the string.
  return str.replace(/(<([^>]+)>)/ig, '');
}



/**
 * Decodes common HTML entities in a string.
 *
 * @param {string} str The string containing HTML entities.
 * @return {string} The string with HTML entities decoded.
 */
export const decodeHtmlEntities = (str) => {
  if ((str === null) || (str === '')) return false;
  str = str.toString();

  // Define a map of common HTML entities and their corresponding characters.
	const entities = {
    '&#8211;': '–', // en dash
    '&#8212;': '—', // em dash
    '&amp;': '&', // ampersand
    '&#038;': '&', // another form of ampersand
    '&lt;': '<', // less than
    '&gt;': '>', // greater than
    '&quot;': '"', // double quote
    '&#039;': "'", // single quote
    '&nbsp;': ' ', // non-breaking space
    '&euro;': '€', // Euro
    '&pound;': '£', // Pound Sterling
    '&yen;': '¥', // Yen
    '&copy;': '©', // Copyright
    '&reg;': '®', // Registered trademark
    '&trade;': '™', // Trademark
    // '&plusmn;': '±', // Plus-minus
    // '&times;': '×', // Multiplication
    // '&divide;': '÷', // Division
    // Add more entities as needed
  };

  // Replace entities in the string with their corresponding characters.
  return str.replace(/&#?\w+;/g, (match) => entities[match] || match);
}

/**
 * Removes HTML tags from a string and decodes HTML entities.
 *
 * This function first strips HTML tags from the input string using a regular
 * expression, then decodes common HTML entities to their corresponding characters.
 *
 * @param {string} str The string to process, containing HTML tags and entities.
 * @return {string} The processed string with HTML tags removed and entities decoded.
 */
export const removeTagsAndDecode = (str) => {
  // Remove HTML tags from the string.
  let textWithoutTags = removeTags(str);
  // Decode HTML entities in the string.
  return decodeHtmlEntities(textWithoutTags);
}


// Funzione per ricavare l'URL troncato
export const getBaseUrl = (url) => {
  // Controlla se l'input è valido e se è una stringa
  if (!url || typeof url !== 'string') return null;

  // Rimuove l'ultima parte dell'URL (dopo l'ultimo slash)
  const urlParts = url.split('/');
  // Rimuove l'ultima parte se non è vuota, altrimenti rimuove le ultime due parti
  if (urlParts[urlParts.length - 1] === '') {
    urlParts.pop(); // rimuove la stringa vuota finale
  }
  urlParts.pop(); // rimuove l'ultima particella

  return urlParts.join('/') + '/';
};
